import DashboardTemplate from '../components/template/DashboardTemplate'
import featureFlags from '../featureFlag/featureFlags'
import {
  socioemotionalPaths,
  settingsPaths,
  messagesPaths,
  announcementsPaths,
  reportsPaths,
  materialPaths,
  pickupPaths
} from './segmentedPaths'

import Login from '../pages/LoginPage'
import Modules from '../pages/ModulesPage'
import NewModulesPage from '../pages/NewModulesPage'
import NewThemesPage from '../pages/NewThemesPage'
import NewContentsPage from '../pages/NewContentsPage'
import Themes from '../pages/ThemesPage'
import Contents from '../pages/ContentsPage'
import CreateModule from '../pages/CreateModulePage'
import CreateTheme from '../pages/CreateThemePage'
import CreateContents from '../pages/CreateContentsPage'
import VersarPage from '../pages/VersarPage'
import ThemePage from '../pages/ThemePage'
import ModulePage from '../pages/ModulePage'
import ContentPage from '../pages/ContentPage'
import ClassroomsPage from '../pages/ClassroomsPage'
import ClassroomPage from '../pages/ClassroomPage'
import PlanningGrades from '../pages/PlanningGradesPage'
import GradeTemplate from '../pages/GradeTemplatePage'
import PlanningSearch from '../pages/PlanningSearchPage'
import ThemeSchedule from '../pages/ThemeSchedulePage'
import ThemeScheduleDate from '../pages/ThemeScheduleDatePage'
import DeleteProfilePage from '../pages/DeleteProfilePage'
import Settings from '../pages/SettingsPage'
import CreateClassroom from '../pages/CreateClassroomPage'
import SettingsClassroom from '../pages/SettingsClassroomPage'
import CreateStudent from '../pages/CreateStudentPage'
import CreateTeacher from '../pages/CreateTeacherPage'
import ReactivateTeacherPage from '../pages/ReactivateTeacherPage'
import SchoolsList from '../pages/SchoolsListPage'
import Messages from '../pages/MessagesPage'
import NewMessages from '../pages/NewMessagesPage'
import Message from '../pages/MessagePage'
import MessagesInbox from '../pages/MessagesInboxPage'
import SendMessage from '../pages/SendMessagePage'
import Announcements from '../pages/AnnouncementsPage'
import AnnouncementsDetails from '../pages/AnnouncementsDetailsPage'
import AnnouncementsConfirmations from '../pages/AnnouncementsConfirmationsPage'
import Reports from '../pages/ReportsPage'
import ReportClassroom from '../pages/ReportClassroomPage'
import ReportStudent from '../pages/ReportStudentPage'
import ReportStudentByClassroom from '../pages/ReportStudentByClassroomPage'
import ReportsPageTemplate from '../pages/ReportsTemplatePage'
import UtilsPage from '../pages/UtilsPage'
import MaterialsPage from '../pages/MaterialsPage'
import CreateCoordinatorPage from '../pages/CreateCoordinatorPage'
import SocioemotionalPage from '../pages/SocioemotionalPage'
import ReactivateCoordinatorPage from '../pages/ReactivateCoordinatorPage'
import ChildrensDisplayPage from '../pages/ChildrensDisplayPage'
import HomePage from '../pages/HomePage'
import PickupPage from '../pages/PickupPage'
import PickupAuthorizationsPage from '../pages/PickupAuthorizationsPage'
import CreatePickupAuthorizationPage from '../pages/CreatePickupAuthorizationPage'
import PickupPendingPage from '../pages/PickupPendingPage'
import PickupManualPage from '../pages/PickupManualPage'
import PickupHistoryPage from '../pages/PickupHistoryPage'
import CreateDoormanPage from '../pages/CreateDoormanPage'

// access
import { accessUtils, accessHomepage, roles } from '../utils/constants'

/**
 * Only logged users can access these routes
 *
 * - Major precedence when user IS LOGGED:
 *    Overwrites the same paths of the public routes
 * - No match when user IS NOT LOGGED:
 *    Render LoginPage component by default
 */
const getRelativeComponent = (feature, path) => {
  switch (feature) {
    case 'socioemotional':
      switch (path) {
        case '/modules':
          return Modules

        case '/socioemotional':
          return SocioemotionalPage

        case '/newmodules':
        case '/newmodules/create':
        case '/newmodules/:moduleId/edit':
          return NewModulesPage

        case '/newmodules/:moduleId/themes/create':
        case '/newthemes':
        case '/newthemes/create':
        case '/newthemes/:themeId/contents':
        case '/newthemes/:themeId/preview':
        case '/newthemes/:themeId/edit':
          return NewThemesPage

        case '/newcontents/:themeId/create':
        case '/newcontents/:themeId/edit/:contentId':
          return NewContentsPage

        case '/modules/create':
        case '/modules/:id/edit':
          return CreateModule

        case '/modules/:id':
          return ModulePage

        case '/themes':
          return Themes

        case '/themes/create':
        case '/themes/:id/edit':
          return CreateTheme

        case '/themes/:id':
          return ThemePage

        case '/contents':
          return Contents

        case '/contents/create':
        case '/contents/:id/edit':
          return CreateContents

        case '/contents/:id':
          return ContentPage

        case '/classrooms':
          return ClassroomsPage

        case '/classrooms/:id':
          return ClassroomPage

        case '/planning/grades':
        case '/theme-schedule/grades':
        case '/theme-schedule/schools/:schoolId/grades':
          return PlanningGrades

        case '/planning/grades/:gradeId':
          return GradeTemplate

        case '/planning/grades/:gradeId/search':
        case '/theme-schedule/schools/:schoolId/grades/:gradeId/:templateId/search':
        case '/theme-schedule/grades/:gradeId/:templateId/search':
          return PlanningSearch

        case '/theme-schedule/schools':
          return SchoolsList

        case '/theme-schedule/schools/:schoolId/grades/:gradeId':
        case '/theme-schedule/grades/:gradeId':
          return ThemeSchedule

        case '/theme-schedule/schools/:schoolId/grades/:gradeId/:templateId':
        case '/theme-schedule/grades/:gradeId/:templateId':
          return ThemeScheduleDate

        default:
          return null
      }
    case 'settings':
      switch (path) {
        case '/settings':
        case '/settings/covers':
        case '/settings/classrooms':
        case '/settings/teachers':
        case '/settings/coordinator':
        case '/settings/moderation':
        case '/settings/layout':
        case '/settings/historic':
        case '/settings/doorman':
          return Settings

        case '/settings/delete_profile':
          return DeleteProfilePage

        case '/settings/classrooms/new':
        case '/settings/classrooms/:classId/edit':
          return CreateClassroom

        case '/settings/classrooms/:classId':
          return SettingsClassroom

        case '/settings/classrooms/:classId/students/new':
        case '/settings/classrooms/:classId/students/:childId':
          return CreateStudent

        case '/settings/teachers/new':
        case '/settings/teachers/:teacherId/edit':
          return CreateTeacher

        case '/settings/teachers/reactivate':
          return ReactivateTeacherPage

        case '/settings/coordinator/new':
        case '/settings/coordinator/:coordinatorId/edit':
          return CreateCoordinatorPage

        case '/settings/coordinator/reactivate':
          return ReactivateCoordinatorPage

        case '/settings/doorman/create':
        case '/settings/doorman/:id':
          return CreateDoormanPage

        default:
          return null
      }
    case 'messages':
      switch (path) {
        case '/rooms':
        case '/rooms/:chatId':
          return NewMessages

        case '/messages':
        case '/messages/schools/:schoolId':
          return Messages

        case '/messages/schools':
          return SchoolsList

        case '/messages/inbox':
        case '/messages/schools/:schoolId/inbox':
          return MessagesInbox

        case '/messages/inbox/:communicationId':
        case '/messages/schools/:schoolId/inbox/:communicationId':
          return Message

        case '/messages/create':
        case '/messages/schools/:schoolId/create':
          return SendMessage

        default:
          return null
      }
    case 'announcements':
      switch (path) {
        case '/announcements':
        case '/announcements/create':
        case '/announcements/:eventId':
        case '/announcements/edit/:eventId':
        case '/announcements/review/:eventId':
          return Announcements

        case '/announcements/:eventId/details':
          return AnnouncementsDetails

        case '/announcements/:eventId/confirmations':
          return AnnouncementsConfirmations

        default:
          return null
      }
    case 'reports':
      switch (path) {
        case '/reports':
        case '/reports/create':
          return Reports

        case '/reports/:reportId/classroom':
          return ReportClassroom

        case '/reports/:reportId/classroom/:reportStudentId':
          return ReportStudent

        case '/reports/:reportId/classroom/all/students':
          return ReportStudentByClassroom

        case '/report_template/:reportTemplateId':
          return ReportsPageTemplate

        case '/report_student/details':
          return ChildrensDisplayPage

        default:
          return null
      }
    case 'materials':
      switch (path) {
        case '/materials':
        case '/materials/create':
        case '/materials/:materialId':
        case '/materials/:materialId/edit':
        case '/materials/:materialId/report':
          return MaterialsPage

        default:
          return null
      }
    case 'pickup':
      switch (path) {
        case '/pickup':
          return PickupPage

        case '/pickup/authorizations':
          return PickupAuthorizationsPage

        case '/pickup/authorization/create':
        case '/pickup/authorization/:id':
          return CreatePickupAuthorizationPage

        case '/pickup/pending':
          return PickupPendingPage

        case '/pickup/manual':
          return PickupManualPage

        case '/pickup/today':
        case '/pickup/history':
          return PickupHistoryPage

        default:
          return null
      }
    default:
      return null
  }
}

const formatPaths = (feature, paths) =>
  paths.map(item => {
    const component = getRelativeComponent(feature, item.path)

    if (!component) {
      throw new Error(
        `[routes] Componente não encontrado para ${feature}: ${item.path}`
      )
    }

    return {
      ...item,
      component,
      template: DashboardTemplate
    }
  })
const socioemotionalCompletedPaths = formatPaths(
  'socioemotional',
  socioemotionalPaths
)

const getAvailableSettingsPaths = () => {
  let availablePaths = settingsPaths

  if (!featureFlags.coordinatorFeature) {
    availablePaths = availablePaths.filter(
      path => !path.path.includes('coordinator')
    )
  }

  if (!featureFlags.pickupFeature) {
    availablePaths = availablePaths.filter(
      path => !path.path.includes('doorman')
    )
  }

  return availablePaths
}

const settingsCompletedPaths = formatPaths(
  'settings',
  getAvailableSettingsPaths()
)

const messagesCompletedPaths = formatPaths('messages', messagesPaths)

const announcementsCompletedPaths = formatPaths(
  'announcements',
  announcementsPaths
)

const reportsCompletedPaths = formatPaths('reports', reportsPaths)

const materialCompletedPaths = formatPaths('materials', materialPaths)

const pickupCompletedPaths = featureFlags.pickupFeature
  ? formatPaths('pickup', pickupPaths)
  : []

export const privateRoutes = [
  ...socioemotionalCompletedPaths,
  ...settingsCompletedPaths,
  ...messagesCompletedPaths,
  ...announcementsCompletedPaths,
  ...reportsCompletedPaths,
  {
    path: '/utils',
    component: UtilsPage,
    template: DashboardTemplate,
    permission: accessUtils
  },
  ...materialCompletedPaths,
  {
    path: '/homepage',
    component: HomePage,
    template: DashboardTemplate,
    permission: accessHomepage,
    defaultFor: [
      roles.SCHOOL_ADMIN,
      roles.TEACHER,
      roles.SCHOOL_MODERATOR,
      roles.COORDINATOR,
      roles.OMBUDSMAN,
      roles.FINANCE,
      roles.SECRETARY
    ]
  },
  ...pickupCompletedPaths
]

/**
 * Only not logged users can access these routes
 *
 * - Precedence over same paths of private routes when user IS NOT LOGGED:
 *    Overwrites the login rendering
 * - No match when user IS LOGGED
 *    Redirect to default private route
 */
export const notLoggedRoutes = [
  {
    path: '/',
    component: VersarPage,
    onlyNoAuth: true
  },
  {
    path: '/login',
    component: Login,
    onlyNoAuth: true
  }
]

/**
 * Both logged and not logged users can access these routes
 *
 * - Minor precedence when user IS LOGGED
 *    Is overwritten by the private route with same paths
 * - Major precedence when user IS NOT LOGGED
 *    Overwrites the same paths of the private and not logged routes
 */
export const publicRoutes = [
  // {
  //   path: '/',
  //   component: Home
  // }
]
